import { render, staticRenderFns } from "./GestioneUtenti.vue?vue&type=template&id=4b0b19a0&"
import script from "./GestioneUtenti.vue?vue&type=script&lang=js&"
export * from "./GestioneUtenti.vue?vue&type=script&lang=js&"
import style0 from "./GestioneUtenti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports